if( window.innerWidth < 767){
   console.log("this log is only for mobile")
    document.addEventListener('DOMContentLoaded', () => {

      // Initialize Swiper for Announcement Bar
      const announcementBarSwiper = new Swiper('.announcement-bar-swiper .swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        loop: true,
        freeMode: true,
        speed: 4000,
        autoplay: {
          delay: 1,
          disableOnInteraction: false,
        },
        loopedSlides: document.querySelectorAll('.announcement-bar .swiper-slide').length,
      });

      // Initialize Swiper for Icon with Text
      const iconWithTextSwiper = new Swiper('.icon-with-text .swiper-container', {
        slidesPerView: 3.35,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: '.icon-with-text .swiper-pagination',
          clickable: true,
        },
      });

      // Initialize Swiper for vice tmz section
      const viceTmzMetro = new Swiper('.vice-tmz-mtero-section .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: '.vice-tmz-mtero-section .swiper-pagination',
          clickable: true,
        },
      });
      // Initialize Swiper for shop_by_concern
      const shop_by_concern = new Swiper('.shop_by_concern .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        scrollbar: {
        el: ".shop_by_concern .swiper-scrollbar",
        },

      });

      const quick_absorption = new Swiper('.quick_absorption .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: '.quick_absorption .swiper-pagination',
          clickable: true,
        },
      });

      // Initialize Swiper for advisory_board_section
      const advisory_board_section = new Swiper('.advisory_board_section .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: {
          el: '.advisory_board_section .swiper-pagination',
          clickable: true,
        },
      });

  });
}
